import { useState, useMemo } from "react";
import { Rect } from "react-konva";

import { LibraryImage } from "../../WelcomePageForm/WelcomePageForm";

export interface BackgroundProps {
  color: string;
  backgroundImage?: LibraryImage;
  size: {
    width: number;
    height: number;
  };
}

export const Background = ({ size, color, backgroundImage }: BackgroundProps) => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const backgroundProps = useMemo(() => {
    if (!backgroundImage) {
      return {
        fill: color,
      };
    }

    const imageEl = new Image();
    imageEl.onload = () => {
      setIsImageLoaded(true);
    };
    imageEl.src = backgroundImage.url;
    imageEl.alt = backgroundImage.name ?? "backgroundImage";
    imageEl.style.backgroundRepeat = "no-repeat";

    const imageUniversalScale = Math.max(size.width / (imageEl.width || 1), size.height / (imageEl.height || 1));

    return {
      fill: imageEl ? undefined : color,
      fillPatternImage: imageEl,
      fillPatternRepeat: "no-repeat",
      fillPatternObjectFit: "cover",
      fillPatternScaleX: imageUniversalScale,
      fillPatternScaleY: imageUniversalScale,
    };
  }, [color, backgroundImage, size, isImageLoaded]);

  return <Rect width={size.width} height={size.height} fillPatternObjectFit="contain" {...backgroundProps} />;
};
